import React, { useState, useEffect } from 'react';
import './App.css';
import Navigation from './components/Navigation/Navigation';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage/LoginPage';
import Homepage from './pages/HomePage/HomePage';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import MovieDetails from './pages/MovieDetails/MovieDetails';
import 'bootstrap/dist/css/bootstrap.min.css';
import RegistrationPage from './pages/RegistrationPage/RegistrationPage';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Function to handle logout
  const handleLogout = () => {
    // Clear authentication token from local storage
    localStorage.removeItem('accessToken');
    // Update authentication state
    setIsLoggedIn(false);
  };

  // Effect to check for authentication token on initial load
  useEffect(() => {
    // Check if there's a token in local storage
    const token = localStorage.getItem('accessToken');
    if (token) {
      // If token exists, set authentication state to true
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <div className="App">
      
      <Router>
      <Navigation/>
        <Routes>
          {/* Route for login page */}
          <Route path="/login" element={<LoginPage setIsLoggedIn={setIsLoggedIn} />} />
          <Route path="/register" element={<RegistrationPage setIsLoggedIn={setIsLoggedIn} />} />
          {/* Route for homepage */}
          <Route path="/" element={<Homepage />} />
          <Route path='/movies/:id' element={<MovieDetails />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
